import { useMemo } from 'react'
import { assert } from '@primitives/objects.utils'
import { queryFactory } from '@ui/features/queries/factory'
import { EmptyValidationSuite } from '@ui/lib/validation/lib'
import { defaultNetworks, getNetworks as getNetworksLib } from '../lib/networks'

const { useQuery, fetchQuery, getQueryData } = queryFactory({
  queryKey: () => ({ name: 'networks', version: 5 }) as const,
  queryFn: getNetworksLib,
  validationSuite: EmptyValidationSuite, // no args
  category: 'dex.network',
})

export const useNetworksQuery = () => useQuery({})
export const fetchNetworks = () => fetchQuery({})
export const getNetworks = () =>
  assert(getQueryData({}), 'Do not use this hook while loading, it should be after RootLayout has loaded the networks')

/** Only use this after the networks have been fetched in the RootLayout. Used for legacy code only. */
export const useNetworks = () => {
  const { data, isPending } = useNetworksQuery()
  if (isPending) {
    throw new Error('Do not use this hook while loading, it should be after RootLayout has loaded the networks')
  }
  return { data: data ?? defaultNetworks }
}

export const useNetworkByChain = ({ chainId }: { chainId: number }) => {
  const { data: networks } = useNetworks()
  return {
    data: useMemo(() => assert(networks[chainId], `Network not found with chainId ${chainId}`), [chainId, networks]),
  }
}
